import React from 'react';

interface IProps {
  width?: string;
  height?: string;
  backgroundColor?: string;
  borderRadius?: string;
  boxShadow?: string;
  padding?: string;
  children?: React.ReactNode;
}

const Card = (props: IProps) => {
  const {
    width = '100%',
    height = 'auto',
    backgroundColor = '#333',
    borderRadius = '12px',
    boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)',
    padding = '16px',
    children,
  } = props;

  return (
    <div
      style={{
        minWidth: '0px',
        boxSizing: 'border-box',
        width,
        height,
        backgroundColor,
        borderRadius,
        boxShadow,
        padding,
      }}
    >
      {children}
    </div>
  );
};

export default Card;
